/**
 * View images and details handlers.
 */
import { openImagesModal, openLotDetailsModal } from '../../modules/ui';
import type { TableHandlerDeps } from './types';

export function handleViewImages(id: string, e: Event, deps: TableHandlerDeps): void {
  const { state } = deps;

  const lot = state.lots.find((x: unknown) => (x as { id: string }).id === id);
  if (!lot) return;

  e.preventDefault();
  openImagesModal(lot);
}

export function handleViewDetails(id: string, e: Event, deps: TableHandlerDeps): void {
  const { state } = deps;

  const lot = state.lots.find((x: unknown) => (x as { id: string }).id === id);
  if (!lot) return;

  e.preventDefault();
  openLotDetailsModal(lot);
}
